import React from 'react';
import './App.css';
import './toast.css';

import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import Login from './components/bewise/login';
import LoginExcl from './components/bewise/loginexcl';

import CourseLogin from './components/bewise/courselogin';

import dashboard from "./components/bewise/dashboard";
import dashboardV1 from "./components/bewise/dashboardV1";
import singleReport from "./components/bewise/singleReport";

import reports from "./components/bewise/reports";
import dashboardNew from "./components/bewise/dashboardNew";

import verticalSchool from "./components/bewise/verticalSchool";
import verticalSchoolEdit from "./components/bewise/verticalSchoolEdit";
import verticalSchoolDetail from "./components/bewise/verticalSchoolDetail";

import verticalPreSchool from "./components/bewise/verticalPreSchool";
import verticalPreSchoolEdit from "./components/bewise/verticalPreSchoolEdit";
import verticalPreSchoolDetail from "./components/bewise/verticalPreSchoolDetail";

import verticalTuitions from "./components/bewise/verticalTuitions";
import verticalTuitionEdit from "./components/bewise/verticalTuitionEdit";
import verticalTuitionDetail from "./components/bewise/verticalTuitionDetail";

import verticalAFA from "./components/bewise/verticalAFA";
import verticalAFAEdit from "./components/bewise/verticalAFAEdit";
import verticalAFADetail from "./components/bewise/verticalAFADetail";

import verticalCamps from "./components/bewise/verticalCamps";
import verticalCampsEdit from "./components/bewise/verticalCampsEdit";
import verticalCampsDetail from "./components/bewise/verticalCampsDetail";

import verticalCommunity from "./components/bewise/verticalCommunity";
import verticalCommunityEdit from "./components/bewise/verticalCommunityEdit";
import verticalCommunityDetail from "./components/bewise/verticalCommunityDetail";

import verticalKidsPlayArea from "./components/bewise/verticalKidsPlayArea";
import verticalKidsPlayAreaEdit from "./components/bewise/verticalKidsPlayAreaEdit";

import verticalEvents from "./components/bewise/verticalEvents";
import verticalEventsEdit from "./components/bewise/verticalEventsEdit";
import verticalEventsDetail from "./components/bewise/verticalEventsDetail";

/* CMS */
import cmsMails from "./components/bewise/cmsMails";
import cmsEditMail from "./components/bewise/cmsEditMail";
import cmsWebAds from "./components/bewise/webAds";

import leadList from "./components/bewise/leadList";
import leadDetail from "./components/bewise/leadDetail";
import leadStats from "./components/bewise/leadStats";

import enquiriesList from "./components/bewise/enquiriesList";
import enquiryDetail from "./components/bewise/enquiryDetail";


import cmsSiteContents from "./components/bewise/cmsSiteContents";
import cmsEvents from "./components/bewise/cmsEvents";
import cmsInsights from "./components/bewise/cmsInsights";

import cmsNews from "./components/bewise/cmsNews";
import cmsAddNews from "./components/bewise/cmsAddNews";

import cmsSpecialGuests from "./components/bewise/cmsSpecialGuests";
import cmsAddEditSpecialGuest from "./components/bewise/cmsAddEditSpecialGuest";

import cmsAddEditInsight from "./components/bewise/cmsAddEditInsight";
import customMails from "./components/bewise/customMails";

import paymentsLinks from "./components/bewise/paymentlinks";
import paymentsLinksDetail from "./components/bewise/paymentsLinksDetail";
import paymentTransactions from "./components/bewise/transactions";
import transactionDetail from "./components/bewise/transactionDetail";
import paymentInfo from "./components/bewise/paymentInfo";

/* Admin pages */
import partnerStats from "./components/bewise/partnerStats";

/* User Pages */
import parentList from "./components/bewise/parentList";
import parentDetail from "./components/bewise/parentDetail";

import partnerList from "./components/bewise/partnerList";
import partnerDetail from "./components/bewise/partnerDetail";

import partnerListTrashed from "./components/bewise/trash/partnerList";

import exclusivePartnerList from "./components/bewise/exclusivePartnerList";
import exclusiveUserEdit from "./components/bewise/exclusiveUserEdit";
import exclusiveParterView from "./components/bewise/exclusiveParterView";

import exclusiveParterViewB2B from "./components/bewise/exclusiveParterViewB2B";
import exclusiveParterViewB2C from "./components/bewise/exclusiveParterViewB2C";

import bewiseUsers from "./components/bewise/bewiseUsers";

import bewiseUsersEdit from "./components/bewise/bewiseUsersEdit";

import generalImages from "./components/bewise/generalImages";
import generalCities from "./components/bewise/generalCities";
import generalLocalities from "./components/bewise/generalLocalities";
import generalContacts from "./components/bewise/generalContacts";

import bewisetotal from "./components/bewise/bewisetotal";

/*Admin Access */
import roles from "./components/bewise/adminRoles";
import adminAddRole from "./components/bewise/adminAddRole";

import gst from "./components/bewise/adminGst";
import packages from "./components/bewise/adminPackages";
import editPackage from "./components/bewise/editPackage";
import promoCodes from "./components/bewise/promoCodes";
import resourcesList from "./components/bewise/resourceList";

import bewiseCuratedCamps from "./components/bewise/bewiseCuratedCamps";
import bewiseEditCuratedCamp from "./components/bewise/bewiseEditCuratedCamp";
import ViewPaymentCamp from "./components/bewise/bewiseViewPaymentCamp";

/* partner pages  */
import partnerProfile from "./components/bewise/partners/profile";
import partnerProfile_new from "./components/bewise/partners/profileNew"; 

import partnerDashboard from "./components/bewise/partners/dashboard";
import partnerDashboardV1 from "./components/bewise/partners/dashboardV1";

import partnerReports from "./components/bewise/partners/reports";

import partnerAccountInfo from "./components/bewise/partners/accountinfoV3";
import partnerAccountInfoNew from "./components/bewise/partners/accountinfonew2";

import partnerSubscriptionInfo from "./components/bewise/partners/subscriptioninfo";

import partnerSubscriptionInfov1 from "./components/bewise/partners/subscriptioninfov1";

import partnerBenchMarking from "./components/bewise/partners/benchmarking";
import partnerNews from "./components/bewise/partners/news";
import partnerJobPosting from "./components/bewise/partners/jobposting";

import BenchMarkView from "./components/bewise/partners/benchmark/compare";

import partnerTransactions from "./components/bewise/partners/transactions";
import partnerPaymentLinks from "./components/bewise/partners/paymentlinks";

import partnerBranches from "./components/bewise/partners/branches";

import partnerArticles from "./components/bewise/partners/articles";
import partnerReview from "./components/bewise/partners/review";
import partnerExclusivePartnerShips from "./components/bewise/partners/exclusivepartnerships";

import NewLandingPageIns from "./components/LandingPages/ins_landingpage";

import PlanPageSchools from "./components/LandingPages/plans_schoolspreschools";
import PlanIndIns from "./components/LandingPages/plans_individualandinstitutions";

import NewLandingPageInd from "./components/LandingPages/ind_landingpage";

import InstitutionSignUp from "./components/SignUp/institutional_signup";
import IndividualSignUp from "./components/SignUp/individual_signup";
import IndividualComplete from "./components/SignUp/individual_complete";

import About from './components/Copyrights/about';
import Privacy from './components/Copyrights/privacy';
import Faqs from './components/Copyrights/faq';
import Unsubscribe from './components/Copyrights/unsubscribe';
import Forgot from './components/Login/forget';

import ForgotExcl from './components/Login/forget_excl';

import Termsconditions from './components/Copyrights/termsconditions';
import Register from './components/Login/register';

import subscribersList from './components/bewise/wiseconnect/subscriberslist';
import registeredUsersList from './components/bewise/wiseconnect/registeredUserList';
import newsLetterSubscribersList from './components/bewise/wiseconnect/newsLetterSubscribersList';

import AuroScholars from './components/bewise/exclsignups/auroscholars';

import Wcdashboard  from './components/bewise/wiseconnect/dashboard';
import Wcpostajob  from './components/bewise/wiseconnect/postajob';

import Wcviewjob  from './components/bewise/wiseconnect/viewjob';

import WcAdvisory  from './components/bewise/wiseconnect/advisory';
import Wctalentsearch  from './components/bewise/wiseconnect/talentsearch';

import WctalentViewProfile  from './components/bewise/wiseconnect/viewprofile';
import WcUserViewProfile  from './components/bewise/wiseconnect/userprofile';
import DownloadProfile from './components/bewise/wiseconnect/downloadprofile';

import Wcapplicants  from './components/bewise/wiseconnect/applicants';
import OtherCourses from './components/bewise/wiseconnect/othercourses';
import Addothercourse from './components/bewise/wiseconnect/addothercourse';
import Courses from './components/bewise/wiseconnect/courses';
import Addcourse from './components/bewise/wiseconnect/addcourse';
import Viewcourse from './components/bewise/wiseconnect/viewcourse';

import exclusivePartnerDashboard from "./components/bewise/exclusiveparnter/dashboard";
import exclusivePartnerEdit from "./components/bewise/exclusiveparnter/exclusivePartnerEdit";

import exclusivePartnerParentEdit from "./components/bewise/exclusiveparnter/exclusivePartnerParentEdit";
import exclusivePartnerPartnerEdit from "./components/bewise/exclusiveparnter/exclusivePartnerPartnerEdit";

import schoolList from './components/bewise/duplicates/schoolList';
import preSchoolList from './components/bewise/duplicates/preSchoolList';
import tuitionList from './components/bewise/duplicates/tuitionList';
import afterschoolList from './components/bewise/duplicates/afterschoolList';
import learningcampsList from './components/bewise/duplicates/learningcampsList';
import kidsplayareaList from './components/bewise/duplicates/kidsplayareaList';
import communityList from './components/bewise/duplicates/communityList';
import InvoiceView from "./components/bewise/partners/invoice_new";
import CourseDashboard from "./components/bewise/courses/dashboard";
import AddcourseIns from "./components/bewise/courses/addcourse"; 
import editCourse from './components/bewise/courses/editcourse';
import ListCourse from "./components/bewise/courses/listcourses"; 
import JobsAdmin from './components/bewise/wiseconnect/jobs';
import Addjob from "./components/bewise/wiseconnect/addjob"; 
import Editjob from "./components/bewise/wiseconnect/editjob"; 
import BlogsExtAdmin from './components/bewise/wiseconnect/blogs';
import Addblog from "./components/bewise/wiseconnect/addblog"; 
import Editblog from "./components/bewise/wiseconnect/editblog"; 

import CreateProvider from './components/bewise/wiseconnect/createprovider';

import NewPartnerInstitutionPage from "./components/2023/new_partner_institutions";

import NewPartnerInstitutionPageV1 from "./components/2023/new_partner_institutionsv1";

import ReportV2 from "./components/bewise/reportV2";

import ReportV3  from  "./components/bewise/reportV3";

import partnerBranchAdd from "./components/bewise/partners/branchadd";

import RestartApp from "./components/bewise/restart";

import AzurFileUpload from "./components/bewise/azupload";

import NotFound from "./components/bewise/notFound";

import './assets/bewise_custom.css';

import './viewport.css';

function App() {
  return (
    <Router>

        <Switch>

          <Route path="/" exact component={Login} />
          <Route path="/login" exact component={Login} />
          <Route path="/admin_login" exact component={Login} />
          <Route path="/excl_login" exact component={LoginExcl} />
        
          <Route path="/courselogin" exact component={CourseLogin} />
          <Route path="/courses/dashboard" exact component={CourseDashboard} />
          <Route path="/courses/listcourses" exact component={ListCourse} />
          <Route path="/courses/addcourse" exact component={AddcourseIns} />
          <Route path="/courses/editcourse/:id" exact component={editCourse} /> 

          <Route path="/dashboard/dashboard" exact component={dashboard} />
          <Route path="/dashboard/dashboardV1" exact component={dashboardV1} />

          <Route path="/dashboard/dashboard/bewisetotal" exact component={bewisetotal} />

          <Route path="/dashboard/reports" exact component={reports} />  
          <Route path="/dashboard/reportsnew" exact component={dashboardNew} />  
          <Route path="/dashboard/singlereport/:id" exact component={singleReport} />  

           

          <Route path="/vertical/school" exact component={verticalSchool} />
          <Route path="/vertical/school/add" exact component={verticalSchoolEdit} />
          
          <Route path="/vertical/school/updateschools/:id" exact component={verticalSchoolEdit} />
          <Route path="/vertical/school/schooldetail/:id" exact component={verticalSchoolDetail} />

          <Route path="/vertical/preschool" exact component={verticalPreSchool} />
          <Route path="/vertical/preschool/add" exact component={verticalPreSchoolEdit} />
          <Route path="/vertical/preschool/update/:id" exact component={verticalPreSchoolEdit} />
          <Route path="/vertical/preschool/detail/:id" exact component={verticalPreSchoolDetail} />

          <Route path="/vertical/tuitions" exact component={verticalTuitions} />
          <Route path="/vertical/tuitions/add" exact component={verticalTuitionEdit} />
          <Route path="/vertical/tuition/add" exact component={verticalTuitionEdit} />
          <Route path="/vertical/tuitions/update/:id" exact component={verticalTuitionEdit} />
          <Route path="/vertical/tuitions/detail/:id" exact component={verticalTuitionDetail} />

          <Route path="/vertical/afterschoolactivities" exact component={verticalAFA} />
          
          <Route path="/vertical/afterschoolactivities/add/:id/:type" exact component={verticalAFAEdit} />
          
          <Route path="/vertical/afterschoolactivities/update/:id/:type/:token" exact component={verticalAFAEdit} />

          <Route path="/vertical/afterschoolactivities/detail/:id" exact component={verticalAFADetail} />

          <Route path="/vertical/learningcamps" exact component={verticalCamps} />
          <Route path="/vertical/learningcamps/add" exact component={verticalCampsEdit} />
          <Route path="/vertical/learningcamps/update/:id" exact component={verticalCampsEdit} />
          <Route path="/vertical/learningcamps/detail/:id" exact component={verticalCampsDetail} />

          <Route path="/vertical/kidsplayarea" exact component={verticalKidsPlayArea} /> 
          <Route path="/vertical/kidsplayarea/add" exact component={verticalKidsPlayAreaEdit} />
          <Route path="/vertical/kidsplayarea/update/:id" exact component={verticalKidsPlayAreaEdit} />

          <Route path="/vertical/communitysupports" exact component={verticalCommunity} /> 
          <Route path="/vertical/communitysupports/add" exact component={verticalCommunityEdit} />
          <Route path="/vertical/communitysupports/update/:id" exact component={verticalCommunityEdit} />
          <Route path="/vertical/communitysupports/detail/:id" exact component={verticalCommunityDetail} />


          <Route path="/vertical/birthdayevents" exact component={verticalEvents} />  
          <Route path="/vertical/birthdayevents/add" exact component={verticalEventsEdit} />
          <Route path="/vertical/birthdayevents/update/:ids/:seditid" exact component={verticalEventsEdit} />
          <Route path="/vertical/birthdayevents/detail/:id" exact component={verticalEventsDetail} />

          <Route path="/vertical/afterschoolactivities/add" exact component={verticalAFAEdit} />

          <Route path="/cms/insights" exact component={cmsInsights} /> 
          <Route path="/cms/insights/addinsight" exact component={cmsAddEditInsight} /> 
          <Route path="/cms/insights/edit-blog/:id" exact component={cmsAddEditInsight} /> 

          <Route path="/cms/mails" exact component={cmsMails} /> 
          <Route path="/cms/sitecontents" exact component={cmsSiteContents} />  
          <Route path="/cms/events" exact component={cmsEvents} />  
          <Route path="/cms/websiteads" exact component={cmsWebAds} />  

          <Route path="/cms/specialguests" exact component={cmsSpecialGuests} />  
          <Route path="/cms/specialguests/add" exact component={cmsAddEditSpecialGuest} />  
          <Route path="/cms/specialguests/edit/:id" exact component={cmsAddEditSpecialGuest} />  

          
          <Route path="/cms/news" exact component={cmsNews} />  
          <Route path="/cms/news/addnews" exact component={cmsAddNews} /> 
          <Route path="/cms/news/editnews/:id" exact component={cmsAddNews} />   

          <Route path="/leads/leadlist" exact component={leadList} /> 
          <Route path="/leads/leadDetail/:id" exact component={leadDetail} />   
          <Route path="/leads/stats" exact component={leadStats} /> 

          <Route path="/enquiry/enquiries" exact component={enquiriesList} />  
          <Route path="/enquiry/enquiryDetail/:id" exact component={enquiryDetail} />  
          
          <Route path="/cms/mail/edit/:id" exact component={cmsEditMail} /> 

          <Route path="/general/images" exact component={generalImages} /> 
          <Route path="/general/localities" exact component={generalLocalities} /> 
          <Route path="/general/cities" exact component={generalCities} /> 
          <Route path="/general/contacts" exact component={generalContacts} />  

          <Route path="/admin/roles" exact component={roles} /> 
          <Route path="/admin/roles/add" exact component={adminAddRole} /> 
          <Route path="/admin/roles/edit/:id" exact component={adminAddRole} /> 

          <Route path="/admin/gst" exact component={gst} /> 
          <Route path="/admin/packages" exact component={packages} /> 
          <Route path="/admin/packages/edit/:id" exact component={editPackage} /> 
          <Route path="/admin/promocode" exact component={promoCodes} /> 

          <Route path="/admin/eventresources" exact component={resourcesList} /> 
          <Route path="/admin/custommails" exact component={customMails} /> 
          
          <Route path="/admin/bewisecuratedcamps" exact component={bewiseCuratedCamps} /> 
          <Route path="/admin/bewisecuratedcamps/edit/:camp_id" exact component={bewiseEditCuratedCamp} /> 
          <Route path="/admin/bewisecuratedcamps/viewpayments/:camp_id" exact component={ViewPaymentCamp} />

          <Route path="/payments/paymentlinks" exact component={paymentsLinks} />  
          <Route path="/payments/transactions" exact component={paymentTransactions} /> 

          <Route path="/payments/paymentinfo" exact component={paymentInfo} /> 

          <Route path="/payments/paymentlinks/rzpaylink_transaction_details/:id" exact component={paymentsLinksDetail} />  
          <Route path="/payments/transactions/transactiondetails/:id" exact component={transactionDetail} />   

          <Route path="/stats_partners" exact component={partnerStats} />
          
          <Route path="/users/parents" exact component={parentList} />
          <Route path="/users/parents/parentdetail/:id" exact component={parentDetail} />

          <Route path="/users/partners" exact component={partnerList} />
          <Route path="/users/partners/partnerDetail/:id" exact component={partnerDetail} />

          <Route path="/trash/partners" exact component={partnerListTrashed} />

          <Route path="/users/exclusivepartners" exact component={exclusivePartnerList} />
          <Route path="/users/exclusivepartners/update/:id" exact component={exclusiveUserEdit} />
          <Route path="/users/exclusivepartners/viewexclusivepartership/:id" exact component={exclusiveParterView} />
          <Route path="/users/exclusivepartners/viewexclusivepartership/b2b/:id" exact component={exclusiveParterViewB2B} />
          <Route path="/users/exclusivepartners/viewexclusivepartership/b2c/:id" exact component={exclusiveParterViewB2C} />
          <Route path="/users/exclusivepartners/add" exact component={exclusiveUserEdit} />

          <Route path="/users/bewiseusers" exact component={bewiseUsers} />
          <Route path="/users/bewiseusers/updatebewiseuser/:id" exact component={bewiseUsersEdit} />
          <Route path="/users/bewiseusers/addbewiseuser" exact component={bewiseUsersEdit} />

          <Route path="/exclusiveparnter/dashboard" exact component={exclusivePartnerDashboard} />
          
          <Route path="/exclusiveparnter/create_excl_parent" exact component={exclusivePartnerParentEdit} />
          <Route path="/exclusiveparnter/edit_excl_parent/:id" exact component={exclusivePartnerParentEdit} />
          
          <Route path="/exclusiveparnter/create_excl_partner" exact component={exclusivePartnerPartnerEdit} />
          <Route path="/exclusiveparnter/edit_excl_partner/:id" exact component={exclusivePartnerPartnerEdit} />
          
          <Route path="/exclusiveparnter/create_excl" exact component={exclusivePartnerEdit} />
          <Route path="/exclusiveparnter/edit_excl/:id" exact component={exclusivePartnerEdit} />
          
          <Route path="/institutionbk" exact component={NewLandingPageIns} />   
          <Route path="/individualbk" exact component={NewLandingPageInd} />    

          <Route path="/institution-partners" exact component={NewLandingPageIns} />               
          <Route path="/individual-partners" exact component={NewLandingPageInd} />

          {/*<Route path="/institution" exact component={PlanPageSchools} />  
          <Route path="/individual" exact component={PlanIndIns} />  
          <Route path="/institution/:wc" exact component={PlanPageSchools} />  */}

          <Route path="/individual_signup" exact component={IndividualSignUp} />

          <Route path="/sign-up-individual-partner" exact component={IndividualSignUp} />
          <Route path="/sign-up-institution-partner" exact component={InstitutionSignUp} />

          <Route path="/indsignup/:token/:id" exact component={IndividualComplete} />
          <Route path="/institution_signup" exact component={InstitutionSignUp} />
            
          <Route path="/about" exact component={About} />  
          <Route path="/forgot" exact component={Forgot} />
          <Route path="/forgot_excl" exact component={ForgotExcl} />
          <Route path="/forgot_excl/:ref/:token" exact component={ForgotExcl} />
          <Route path="/forgot/:ref/:token" exact component={Forgot} />
          <Route path="/register" exact component={Register} />
          <Route path="/termsconditions" exact component={Termsconditions} />
          <Route path="/privacy" exact component={Privacy} />
          <Route path="/faq" exact component={Faqs} />
          <Route path='/unsubscribe/:token' component={Unsubscribe} />

          <Route path="/partner/profile" exact component={partnerProfile} />
          <Route path="/partner/profilenew" exact component={partnerProfile_new} />

          <Route path="/partner/dashboard" exact component={partnerDashboard} />
          <Route path="/partner/dashboardV1" exact component={partnerDashboardV1} />

          <Route path="/partner/reportV2" exact component={ReportV2} />
          <Route path="/partner/reportV3" exact component={ReportV3} />


          <Route path="/partner/reports" exact component={partnerReports} />

          <Route path="/partner/accountinfo" exact component={partnerAccountInfo} />
          <Route path="/partner/accountinfonew" exact component={partnerAccountInfoNew} />

          <Route path="/partner/subscriptioninfo" exact component={partnerSubscriptionInfov1} />
          <Route path="/partner/subscriptioninfov1" exact component={partnerSubscriptionInfov1} />
          <Route path="/partner/benchmarking" exact component={partnerBenchMarking} />
          <Route path="/partner/news" exact component={partnerNews} />
          <Route path="/partner/jobposting" exact component={partnerJobPosting} />
          <Route path="/partner/bench_mark_view" exact component={BenchMarkView} />
          <Route path="/partner/transactions" exact component={partnerTransactions} />
          <Route path="/partner/paymentlinks" exact component={partnerPaymentLinks} />
          <Route path="/partner/branches" exact component={partnerBranches} />
          <Route path="/partner/exclusivepartnerships" exact component={partnerExclusivePartnerShips} />
          <Route path="/partner/articles" exact component={partnerArticles} />
          <Route path="/partner/review" exact component={partnerReview} />
          <Route path="/partner/view_invoice/:id" exact component={InvoiceView} />

          <Route path="/partner/wcdashboard" exact component={Wcdashboard} />
          <Route path="/partner/wiseconnect/viewjob/:jobid" exact component={Wcviewjob} />
          <Route path="/partner/wcpostajob" exact component={Wcpostajob} />
          <Route path="/partner/wctalentsearch" exact component={Wctalentsearch} />
          <Route path="/partner/applicants" exact component={Wcapplicants} />
          <Route path="/partner/wiseconnect/applicants/:jobid" exact component={Wcapplicants} />
          <Route path="/partner/wiseconnect/viewprofile/:id/:jobid" exact component={WctalentViewProfile} /> 
          <Route path="/partner/wiseconnect/downloadprofile/:id" exact component={DownloadProfile} /> 
          
          <Route path="/partner/viewprofile" exact component={WctalentViewProfile} />
          <Route path="/partner/wcadvisory" exact component={WcAdvisory} />

          <Route path="/partner/wctalentsearch/viewprofile/:id" exact component={WctalentViewProfile} />  
          <Route path="/duplicates/duplicateinschool" exact component={schoolList} />
          <Route path="/duplicates/duplicateinpreschool" exact component={preSchoolList} />
          <Route path="/duplicates/duplicateintuition" exact component={tuitionList} />
          <Route path="/duplicates/duplicateinafterschool" exact component={afterschoolList} />
          <Route path="/duplicates/duplicateinkidsplayarea" exact component={kidsplayareaList} />
          <Route path="/duplicates/duplicateinlearningcamps" exact component={learningcampsList} />
          <Route path="/duplicates/duplicateincommunity" exact component={communityList} />

          <Route path="/wiseconnect/subscriberslist" exact component={subscribersList} />
          <Route path="/wiseconnect/newslettersubscribers" exact component={newsLetterSubscribersList} />
          <Route path="/wiseconnect/registeredusers" exact component={registeredUsersList} />

          <Route path="/wiseconnect/viewprofile/:id" exact component={WcUserViewProfile} /> 

          <Route path="/exclsignups/auroscholars" exact component={AuroScholars} />
          
          <Route path="/wiseconnect/othercourses" exact component={OtherCourses} />
          <Route path="/wiseconnect/addothercourse" exact component={Addothercourse} />

          <Route path="/wiseconnect/courses" exact component={Courses} />
          <Route path="/wiseconnect/addcourse" exact component={Addcourse} />
          <Route path="/wiseconnect/viewcourse/:id" exact component={Viewcourse} />
         
          <Route path="/wiseconnect/jobs" exact component={JobsAdmin} />
          <Route path="/wiseconnect/addjob" exact component={Addjob} />
          <Route path="/wiseconnect/editjob/:id" exact component={Editjob} />
          
          <Route path="/wiseconnect/externalblogs" exact component={BlogsExtAdmin} />
          <Route path="/wiseconnect/addblog" exact component={Addblog} />
          <Route path="/wiseconnect/editblog/:id" exact component={Editblog} />
          

          <Route path="/wiseconnect/createprovider" exact component={CreateProvider} />
           
          <Route path="/partner/newsubscription" exact component={partnerSubscriptionInfo} />

          <Route path="/plan_schoolpreschools" exact component={PlanPageSchools} />  
          <Route path="/plan_individualandinstitutions" exact component={PlanIndIns} />  
          <Route path="/plan_schoolpreschools/:wc" exact component={PlanPageSchools} />  
          { /*
          <Route path="/bewisepartnerplans" exact component={NewPartnerInstitutionPage} />  
          <Route path="/bewisepartnerplans/:type" exact component={NewPartnerInstitutionPage} /> 
          */}

          <Route path='/bewisepartnerplans' component={() => {
                    window.location.href = '/joinus';
                    return null;
          }}/>

          <Route path="/joinus" exact component={NewPartnerInstitutionPage} />  
          <Route path="/joinus_v1" exact component={NewPartnerInstitutionPageV1} /> 
          <Route path="/joinus/:type" exact component={NewPartnerInstitutionPage} /> 
          <Route path="/azblogtest/fileupload" exact component={AzurFileUpload} />
          <Route path="/partner/addbranch/:login_id" exact component={partnerBranchAdd} />

          <Route path="/restartapp" exact component={RestartApp} />   

          <Route path='/:somerandom' exact component={NotFound} status={404}/>

        </Switch>
    
    </Router>
  );
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js